function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4805 2.30859L13.4414 1.26953C13.1133 0.941406 12.6484 0.75 12.2109 0.75C11.7734 0.75 11.3086 0.941406 10.9805 1.26953L2.23047 10.0195C1.98438 10.2656 1.82031 10.5664 1.73828 10.8945L1 14.2305C0.945312 14.5039 1.16406 14.75 1.41016 14.75C1.4375 14.75 1.49219 14.75 1.51953 14.75C1.51953 14.75 3.81641 14.2578 4.85547 14.0117C5.18359 13.957 5.45703 13.793 5.70312 13.5469L14.4805 4.76953C15.1641 4.08594 15.1641 2.99219 14.4805 2.30859ZM5.07422 12.9453C4.96484 13.0547 4.82812 13.1367 4.66406 13.1641C3.98047 13.3281 2.75 13.6016 2.01172 13.7656L2.61328 11.0859C2.64062 10.9219 2.72266 10.7578 2.83203 10.6484L9.61328 3.86719L11.8828 6.13672L5.07422 12.9453ZM13.8516 4.14062L12.4844 5.53516L10.2148 3.26562L11.582 1.89844C11.7461 1.73438 11.9648 1.625 12.2109 1.625C12.457 1.625 12.6758 1.73438 12.8398 1.89844L13.8516 2.91016C14.207 3.26562 14.207 3.8125 13.8516 4.14062Z",
  fill: "#080707"
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.55d79b5a.svg";
export { ForwardRef as ReactComponent };